"use client";
import { TopBannerQuery } from "@/__generated__/sdk";
import React, { createContext, useContext, PropsWithChildren, useMemo } from "react";
import { bannerHasContent } from "./TopBanner/bannerContent";
import { bannerOptions } from "./TopBanner/bannerOptions";

export type SiteTopBanner = NonNullable<TopBannerQuery["topBanner"]>;

type AppContextValue = {
  hasBanner: boolean;
  bannerOptions: typeof bannerOptions;
  banner: SiteTopBanner | null;
};

const AppContext = createContext<AppContextValue | undefined>(undefined);

export function AppProvider({
  children,
  banner = null,
}: PropsWithChildren<{ banner?: TopBannerQuery["topBanner"] }>) {
  const value = useMemo<AppContextValue>(
    () => ({
      hasBanner: bannerHasContent(banner),
      bannerOptions,
      banner: banner ?? null,
    }),
    [banner],
  );

  return <AppContext.Provider value={value}>{children}</AppContext.Provider>;
}

export function useAppContext() {
  const ctx = useContext(AppContext);
  if (!ctx) {
    throw new Error("useAppBar must be used inside <AppProvider />");
  }
  return ctx;
}
